import { Award, GraduationCap } from 'lucide-react';
import { format } from 'date-fns';
import { ProfileInfoProps } from "../types";

export const ProfileInfo = ({ 
  fullName, 
  headline, 
  bio, 
  artistCategory,
  education,
  certifications 
}: ProfileInfoProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-[2fr,1fr] gap-8">
      {/* Left Column - Main Profile Info */}
      <div className="space-y-4">
        <div className="space-y-2">
          <div className="font-medium text-xl">{fullName}</div>
          {artistCategory && (
            <div className="text-sm text-primary font-medium">
              {artistCategory.name}
            </div>
          )}
          <div className="text-muted-foreground">{headline}</div>
          <div className="whitespace-pre-wrap text-sm">{bio}</div>
        </div>
      </div>

      {/* Right Column - Certificates and Education */}
      <div className="space-y-8">
        {/* Certificates Section */}
        {certifications && certifications.length > 0 && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <Award className="h-5 w-5" />
              Certificates
            </h3>
            <div className="space-y-4">
              {certifications.map((cert) => (
                <div key={cert.id} className="space-y-1">
                  <div className="font-medium">{cert.title}</div>
                  <div className="text-sm text-muted-foreground">
                    {cert.institution} • {format(new Date(cert.issue_date), 'MMM yyyy')}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Education Section */}
        {education && education.length > 0 && (
          <div className="space-y-4">
            <h3 className="text-lg font-semibold flex items-center gap-2">
              <GraduationCap className="h-5 w-5" />
              Education
            </h3>
            <div className="space-y-4">
              {education.map((edu) => (
                <div key={edu.id} className="space-y-1">
                  <div className="font-medium">{edu.degree}</div>
                  <div className="text-sm text-muted-foreground">
                    {edu.institution} • {format(new Date(edu.start_date), 'MMM yyyy')} - {' '}
                    {edu.end_date ? format(new Date(edu.end_date), 'MMM yyyy') : 'Present'}
                  </div>
                  {edu.field_of_study && (
                    <div className="text-sm text-muted-foreground">{edu.field_of_study}</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};